import { useAuth } from '@/store/auth/auth.store';
import { UserRole } from '@/utils/roles';

import { useRoles } from './useRoles';

export const useIsServiceProvider = () => {
  const { primaryRole } = useRoles();
  const session = useAuth((state) => state.session);

  const isServiceProvider = primaryRole === UserRole.SERVICE_PROVIDER;
  const ownServiceProviderId = session?.services?.find(
    (r) => r.service_type === 'service-provider',
  )?.service_id;

  return { isServiceProvider, ownServiceProviderId };
};
